<template>
  <TTabsToggle
    :show-remove="index > 1"
    :data-testid="`carousel-item-${index}`"
    :header="`&nbsp;`"
    @removeBlock="removeItem(index)"
  >
    <template v-if="src" #icon>
      <img :src="src" :height="20" />
    </template>

    <template v-if="!src" #headerContent>
      <ImageButtons v-model="src" :show-edit="false" :index="index" xs />
    </template>

    <menu-content-container :padding-left-right="8">
      <content-row>
        <ImageButtons v-model="src" :index="index" show-replace />
      </content-row>
      <content-row>
        <t-input v-model="href" :label="$t('forms.image_link')"></t-input>
      </content-row>

      <content-row>
        <t-input v-model="src" :label="$t('forms.image_url')"></t-input>
      </content-row>

      <content-row>
        <t-input v-model="alt" :label="$t('forms.image_alt')"></t-input>
      </content-row>

      <content-row>
        <t-input v-model="title" :label="$t('forms.image_title')"></t-input>
      </content-row>
    </menu-content-container>
  </TTabsToggle>
</template>

<script setup lang="ts">
  import CarouselItemType from "./CarouselItem";
  import ImageButtons from "../ImageButtons/ImageButtons.vue";
  import { useMjmlStore } from "@/stores/mjmlStore";
  import { TopolCarouslBlock } from "@/schemas/template/blocks/carouselBlockSchema";
  import { TInput, TTabsToggle } from "@topol/twig-ui";
  import { computed } from "vue";

  const mjmlStore = useMjmlStore();

  const props = defineProps<{
    item: CarouselItemType;
    index: number;
  }>();

  const update = (key: string, value: unknown) => {
    mjmlStore.updateBlockChildrenAttribute({
      childIndex: props.index,
      prop: key,
      value: value,
    });
  };

  function removeItem(index: number) {
    if (!mjmlStore.selectedBlock || !activeBlock.value) {
      return;
    }

    if (activeBlock.value.children.length < 3) {
      //should throw an dialog that cant be removed because of
      return;
    }

    mjmlStore.deleteBlockChild({
      sectionIndex: mjmlStore.selectedBlock.sectionIndex,
      columnIndex: mjmlStore.selectedBlock.columnIndex,
      blockIndex: mjmlStore.selectedBlock.blockIndex,
      childIndex: index,
    });
  }

  const alt = computed({
    get(): string {
      return props.item.attributes.alt || "";
    },
    set(newValue: string): void {
      update("alt", newValue);
    },
  });

  const src = computed({
    get(): string {
      return props.item.attributes.src || "";
    },
    set(newValue: string): void {
      update("src", newValue.trim());
    },
  });

  const title = computed({
    get(): string {
      return props.item.attributes.title || "";
    },
    set(newValue: string): void {
      update("title", newValue);
    },
  });

  const href = computed({
    get(): string {
      return props.item.attributes.href || "";
    },
    set(newValue: string): void {
      update("href", newValue.trim());
    },
  });

  const activeBlock = computed(
    () => mjmlStore.getActiveBlock as TopolCarouslBlock
  );
</script>
